module.exports = __webpack_public_path__ + "static/logistic-growth-bf6dc81e2972e7d8f84ac3131d3d5eae.svg";